(function($) {

  $(document).ready(function() {
    $('.menu-scroll').once('sw-menu-scroll').each(function() {
      var t = new MenuScroll($(this));
    });
  });

  $(window).resize(function() {
    $('.menu-scroll').each(function() {
      const m = $(this).data('sw-menu-scroll')
      if ( m ) {
        m.on_resize();
      }
    });
  });

  $(window).scroll(function() {
    $('.menu-scroll').each(function() {
      const m = $(this).data('sw-menu-scroll')
      if ( m ) {
        m.on_scroll();
      }
    });
  });

})(jQuery);

class MenuScroll{

  constructor($wrap) {
    var _this = this;

    this.$wrap = $wrap;
    this.$content = $wrap.find('.block__content');
    this.$links = $wrap.find('.menu-scroll__link');

    this.$wrap.data('sw-menu-scroll', this);
  }

  on_resize() {
    if ( !is_mobile()) {
      this.$wrap.height(this.$content.height());
    } else {
      this.$wrap.css('height', 'auto');
    }
  }

  on_scroll() {
    if ( is_mobile() ) {
      return;
    }
    const st = jQuery(window).scrollTop();
    const wh = jQuery(window).height();
    const stm = st + wh/2;

    // Fixing
    const ot = this.$wrap.offset().top;
    const is_hc = jQuery('body').hasClass('body--header-scrolled');
    let hh = jQuery('.header').height();
    if ( is_hc ) {
      hh = 0;
    }
    this.$content.css('top', hh);
    if ( st + hh > ot ) {
      this.$wrap.addClass('menu-scroll--fixed');
    } else {
      this.$wrap.removeClass('menu-scroll--fixed');
    }

    // Nav
    this.$links.each(function(i) {
      const $l = jQuery(this);
      const href = $l.find('a').attr('href');
      const $b = find_element_by_link(href);
      if ( $b ) {
        const bs = $b.offset().top;
        const be = $b.offset().top + $b.outerHeight();
        if ( stm > be ) {
          $l.addClass('menu-scroll__link--past');
          $l.removeClass('menu-scroll__link--active');
        } else if ( stm > bs && stm <= be ) {
          $l.removeClass('menu-scroll__link--past');
          $l.addClass('menu-scroll__link--active');
        } else {
          $l.removeClass('menu-scroll__link--past');
          $l.removeClass('menu-scroll__link--active');
        }
      }
    })
  }

}
